<template>
    <div>
        <el-breadcrumb class="Breadcrumb" separator="/">
            <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
            <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>
        <div class="search">
            <el-row :gutter="24">
                <el-col :span="6" :offset="0">
                    <el-input v-model="name" placeholder="请输入姓名/昵称/电话"></el-input>
                </el-col>
                <el-col :span="6" :offset="0">
                    <el-select v-model="type" filterable clearable placeholder="请选择" style="width: 100%;">
                        <el-option v-for="item in typeSelect" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="getListFun(1)" icon="el-icon-search">查询</el-button>
                </el-col>
            </el-row>
        </div>
        <el-divider></el-divider>
        <div class="table">
            <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column prop="nickName" label="昵称">
                </el-table-column>
                <el-table-column prop="mobile" label="电话">
                </el-table-column>
                <el-table-column prop="realName" label="真实姓名">
                </el-table-column>
                <el-table-column prop="idNumber" label="身份证号">
                </el-table-column>
                <el-table-column prop="companyName" label="企业名称">
                </el-table-column>
                <el-table-column prop="loginTarget" label="登录目标">
                </el-table-column>
                <el-table-column prop="id" fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button v-if="!scope.row.companyUser" @click="showResume(scope.row.id)" type="text"
                            icon="el-icon-search" size="small">查看简历</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--分页-->
        <div class="pagination">
            <el-pagination background @size-change="changSizeFun" @current-change="changpageFun"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum">
            </el-pagination>
        </div>

        <!-- 查看简历弹窗-->
        <el-dialog title="查看简历" :visible.sync="resume" width="40%">
            <el-row type="flex" class="row-bg">
                <el-col :span="20">
                    <el-descriptions :title="resumeData.name" :column="3">
                        <el-descriptions-item label="年龄" :span="1">{{ resumeData.age }}</el-descriptions-item>
                        <el-descriptions-item label="性别" :span="1">{{ resumeData.sex }}</el-descriptions-item>
                        <el-descriptions-item label="当前状态">{{ resumeData.currentStatus }}</el-descriptions-item>
                        <el-descriptions-item label="工作经验" :span="1">{{ resumeData.experienceDdic }}</el-descriptions-item>
                        <el-descriptions-item label="学历">{{ resumeData.educationDdic }}</el-descriptions-item>
                        <el-descriptions-item label="手机号">{{ resumeData.mobile }}</el-descriptions-item>
                    </el-descriptions>
                </el-col>
                <el-col :span="6">
                    <el-image style="width: 120px; height: 120px" :src="resumeData.image" :fit="fit"></el-image>
                </el-col>
            </el-row>
            <el-descriptions title="期望职位：" :column="4">
                <el-descriptions-item label="行业" :span="1">{{ resumeData.jobDdic }}</el-descriptions-item>
                <el-descriptions-item label="工作类型" :span="1">{{ resumeData.jobType }}</el-descriptions-item>
                <el-descriptions-item label="期望工资">{{ resumeData.salaryDdic }}</el-descriptions-item>
                <el-descriptions-item label="期望工作地" :span="1">{{ resumeData.workingArea }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="工作经历：" :column="3">
                <template v-for="item in resumeData.workList">
                    <el-descriptions-item label="公司" :span="1">{{ item.name }}</el-descriptions-item>
                    <el-descriptions-item label="开始时间" :span="1">{{ item.startTime }}</el-descriptions-item>
                    <el-descriptions-item label="结束时间" :span="1">{{ item.endTime }}</el-descriptions-item>
                    <el-descriptions-item label="工作说明" :span="3">{{ item.describe }}</el-descriptions-item>
                </template>
            </el-descriptions>
            <el-descriptions title="项目经历：" :column="3">
                <template v-for="item in resumeData.projectList">
                    <el-descriptions-item label="项目名称" :span="1">{{ item.name }}</el-descriptions-item>
                    <el-descriptions-item label="开始时间" :span="1">{{ item.startTime }}</el-descriptions-item>
                    <el-descriptions-item label="结束时间" :span="1">{{ item.endTime }}</el-descriptions-item>
                    <el-descriptions-item label="项目说明" :span="3">{{ item.describe }}</el-descriptions-item>
                </template>
            </el-descriptions>
            <el-descriptions title="教育经历：" :column="3">
                <template v-for="item in resumeData.educationList">
                    <el-descriptions-item label="学校名称" :span="1">{{ item.name }}</el-descriptions-item>
                    <el-descriptions-item label="开始时间" :span="1">{{ item.startTime }}</el-descriptions-item>
                    <el-descriptions-item label="结束时间" :span="1">{{ item.endTime }}</el-descriptions-item>
                </template>
            </el-descriptions>
            <el-descriptions :column="4" direction="vertical">
                <el-descriptions-item label="自我评价" :span="4" label-class-name="my-label">{{ resumeData.makeOneself
                }}</el-descriptions-item>
            </el-descriptions>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="resume = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    mounted() {
        this.getList();
        this.getSelectType();
    },
    methods: {
        //查询列表
        getList() {
            let data = {
                name: this.name,
                type: this.type,
                pageSize: this.pageSize,
                pageNum: this.pageNum,
            }
            this.$get(api + "/userManager/getList", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.tableData = res.data;
                    this.totalNum = res.totalNum
                }
            })
        },
        //获取用户类型下拉
        getSelectType() {
            // let data = {}
            // this.$get(api + "/adminUser/getSelectRole", data).then(response => {
            //     let res = response.data;
            //     console.log(response)
            //     if (res.code == 0) {
            //         this.roleSelect = res.data;
            //     }
            // })
            this.typeSelect = [
                {
                    id: 1,
                    name: '企业用户',
                },
                {
                    id: 2,
                    name: '个人用户',
                },
            ]
        },
        showResume(val) {
            let data = {};
            this.$get(api + "/userManager/getResume/" + val, data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.resumeData = res.data
                    this.resume = true;
                } else {
                    this.$message.error(res.desc);
                }
            })

        },
        //特定pageNum查询列表
        getListFun(val) {
            this.pageNum = val;
            this.getList();
        },

        //更换pageSize
        changSizeFun(val) {
            console.log(`每页 ${val} 条`);
            this.getListFun(val);
        },
        //翻页
        changpageFun(val) {
            console.log(this.pageNum);
            this.getListFun(val);
        },

    },
    data() {
        return {
            //加载数据
            typeSelect: [],
            pageSize: 10,
            pageNum: 1,
            totalNum: 0,

            //查询条件
            name: '',
            type: '',
            //table数据
            tableData: [],
            //弹窗
            resume: false,
            //用户简历
            resumeData: {

            }
        }
    }
}
</script>


<style>
.Breadcrumb {
    _box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}


.el-row {
    margin-bottom: 20px;
}

.el-col {
    border-radius: 0px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.grid-content {
    border-radius: 0px;
    min-height: 36px;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}

.my-label {
    /* font-weight: bold; */
    font-size: 16px;
    font-weight: 700 !important;
    color: #303133 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/UserManager.vue